import service from '@/middleware'

const categoryApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = pageSize != null && pageNumber != null
            ? `/api/category/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/category/all?headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de categorías para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal(enterpriseIds) {
        const result = await service.http.post(`/api/category/total`, enterpriseIds)
        return result
    },
    /**
     * Para obtener una categoría con el id enviado como param
     * @param {*} categoryId
     */
    async getCategory(categoryId) {
        const result = await service.http.get(`/api/category/${categoryId}`)
        return result
    },
    /**
     * Para obtener las categorías con el enterpriseId enviado como parámetro
     * @param {*} enterpriseId
     */
    async getCategoriesByEnterpriseId(enterpriseId) {
        const result = await service.http.get(`/api/category/by-enterprise/${enterpriseId}`)
        return result
    },
    /**
     * Para validar el nombre de una categoría
     * @param {*} name
     */
    async validateCategoryName(name) {
        const result = await service.http.get(`/api/category/validate-name/${name}`)
        return result
    },
    /**
     * Para crear una nueva categoría
     * @param {*} categoryDto
     * @param {*} zonePoiIds
     */
    async create(categoryDto, zonePoiIds) {
        const result = await service.http.post(`/api/category/create`, { categoryDto, zonePoiIds })
        return result
    },
    /**
     * Para actualizar una categoría
     * @param {*} categoryDto
     * @param {*} zonePoiIds
     */
    async update(categoryDto, zonePoiIds) {
        const result = await service.http.put(`/api/category/update`, { categoryDto, zonePoiIds })
        return result
    },
    /**
     * Para eliminar una categoría
     * @param {*} id
     */
    async deleteOne(id) {
        const result = await service.http.delete(`/api/category/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany(ids) {
        const result = await service.http.put(`/api/category/multiple-delete`, ids)
        return result
    },
    /**
     * Obtener las categorías
     */
    async getAll() {
        const result = await service.http.get(`/api/category/all`)
        return result
    },
}

export default categoryApi